module.exports = __webpack_public_path__ + "static/restaurant-closing-checklist-29dc4d59bfd9eeb47e9f407a7b84f3d4.jpg";